export default "__VITE_ASSET__Cdode$Y3__"